import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import Wingman from './Wingman';

export const Layout = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-[#F5F5F5]">
      <Navbar />
      <main className="pt-20">
        <Outlet />
      </main>
      <Footer />
      <Wingman />
    </div>
  );
};
